import React from 'react';
import { Box, Switch, FormLabel } from '@material-ui/core';

function NFT({ subscription, toggleSubscription, disabled, comped }) {
  return (
    <Box>
      <FormLabel>{comped ? 'Disable' : 'Enable'} Comped </FormLabel>
      <Switch
        onChange={() => toggleSubscription(subscription?.id)}
        checked={comped ? true : false}
        disabled={disabled}
      />
    </Box>
  );
}

export default NFT;
